const UNIT = 8;
const Base = {
  unit: UNIT,
  none: 0,
  extraSmall: UNIT / 2,
  small: UNIT,
  medium: UNIT * 2,
  large: UNIT * 4,
  extraLarge: UNIT * 5,
};
export const Spacing = {
  ...Base,
  // The standard or "normal" spacing. A component might have a different
  // "normal" spacing. This is just the generic default spacing.
  normal: Base.small,
};
